
export default class SendMessageForm {
	constructor(app){
		this.app = app;
		this.reset();
	}

	reset(){
		Object.assign(this, {
			messageToken:'',
			messageSubject:'',
			messageBody:'',
		});
	}

	async submit(){
		this.app.startLoadingForm(this);
		try{
			this.app.validate(!!this.messageToken, "You must provide a message token")
			this.app.validate(!!this.messageBody, "You must provide a message.")
			this.app.validate(!!this.messageSubject, "You must provide a subject")
			//this.app.validate(!!this.messageReplyTo, "You must provide a reply-to email address")
			await this.app.http.sendEmail({messageToken:this.messageToken, messageBody:this.messageBody, messageSubject: this.messageSubject});
			this.app.showFlashMessage({label:'SUCCESS! An email has been sent!'});
			this.app.stopLoadingForm(this);
		}catch(e){
			//this.app.showFlashMessage({label:e.toString(), color:'red'});
			this.app.stopLoadingForm(this, e);
		}
	}
}



// WEBPACK FOOTER //
// ./src/models/SendMessageForm.js